/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactSubmissionRecordFromJSON, ContactSubmissionRecordToJSON } from './ContactSubmissionRecord';
/**
 * Check if a given object implements the ContactSubmissionsRecentResponse interface.
 */
export function instanceOfContactSubmissionsRecentResponse(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('submissions' in value) || value['submissions'] === undefined)
        return false;
    return true;
}
export function ContactSubmissionsRecentResponseFromJSON(json) {
    return ContactSubmissionsRecentResponseFromJSONTyped(json, false);
}
export function ContactSubmissionsRecentResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'submissions': (json['submissions'].map(ContactSubmissionRecordFromJSON)),
    };
}
export function ContactSubmissionsRecentResponseToJSON(json) {
    return ContactSubmissionsRecentResponseToJSONTyped(json, false);
}
export function ContactSubmissionsRecentResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'submissions': (value['submissions'].map(ContactSubmissionRecordToJSON)),
    };
}
